
import React from 'react';
import { useGuitarMatch } from '../../context/GuitarMatchContext';

export const UserManual: React.FC = () => {
    const { lang } = useGuitarMatch();
    const isFr = lang === 'fr';

    const sections = isFr ? [
        {
            title: "1. Le Concept Match&Play",
            content: "Guitar Match&Play compare votre signal audio/vidéo à celui d'un 'Master' (Professeur ou Artiste). L'IA analyse les onsets (attaques) et le spectre fréquentiel pour valider votre calage et votre justesse.",
            icon: "🎸"
        },
        {
            title: "2. Préparation du Studio",
            content: "Avant d'enregistrer, effectuez toujours une calibration (Bouton Optimiser Studio). Cela permet à l'IA de soustraire la latence naturelle de votre carte son pour un jugement précis à la milliseconde.",
            icon: "⚙️"
        },
        {
            title: "3. Analyse & Rapports",
            content: "Une fois le MATCH! lancé, l'IA Gemini génère un 'Deep Report'. Vous y trouverez des conseils personnalisés. Utilisez l'onglet 'Vision Lab' pour vérifier si la position de votre pouce ou de votre poignet est correcte.",
            icon: "👁️"
        },
        {
            title: "4. L'Arena & Défis",
            content: "Le mode Arena vous permet de défier d'autres membres du Club sur des morceaux imposés. Votre score détermine votre XP et débloque des récompenses dans votre galerie de trophées.",
            icon: "⚔️"
        }
    ] : [
        {
            title: "1. The Match&Play Concept",
            content: "Guitar Match&Play compares your audio/video signal with a 'Master' (Teacher or Artist). The AI analyzes onsets (attacks) and frequency spectrum to validate your timing and pitch.",
            icon: "🎸"
        },
        {
            title: "2. Studio Preparation",
            content: "Always perform a calibration (Optimize Studio button) before recording. This allows the AI to subtract your sound card's natural latency for precise millisecond evaluation.",
            icon: "⚙️"
        },
        {
            title: "3. Analysis & Reports",
            content: "Once MATCH! is launched, the Gemini AI generates a 'Deep Report'. You'll find personalized advice there. Use the 'Vision Lab' tab to check your thumb or wrist position.",
            icon: "👁️"
        },
        {
            title: "4. Arena & Challenges",
            content: "Arena mode lets you challenge other Club members on specific tracks. Your score determines your XP and unlocks rewards in your trophy gallery.",
            icon: "⚔️"
        }
    ];

    return (
        <div className="space-y-8 animate-fade-in">
            {sections.map((s, i) => (
                <div key={i} className="bg-white/5 border border-white/10 p-8 rounded-[32px] group hover:bg-white/[0.08] transition-all">
                    <div className="flex gap-6 items-start">
                        <div className="w-14 h-14 rounded-2xl bg-black/40 border border-white/10 flex items-center justify-center text-2xl shrink-0 group-hover:scale-110 transition-transform">
                            {s.icon}
                        </div>
                        <div className="space-y-2">
                            <h4 className="text-xl font-black text-white uppercase italic tracking-tighter">{s.title}</h4>
                            <p className="text-slate-400 text-sm leading-relaxed italic">{s.content}</p>
                        </div>
                    </div>
                </div>
            ))}
            
            <div className="p-8 bg-smart-gold/10 border border-smart-gold/20 rounded-[32px] text-center">
                <p className="text-xs font-black text-smart-gold uppercase tracking-widest">{isFr ? 'Une question technique ? Contactez le support GSC.' : 'Technical question? Contact GSC support.'}</p>
            </div>
        </div>
    );
};
